const nameCollator = new Intl.Collator('tr', { sensitivity: 'base' });

function sequence(row) {
    const value = Number(row?.ST_SIRA);
    return Number.isFinite(value) && value !== 0 ? value : null;
}

/** Explicit sequence numbers come first; unnumbered and tied items use Turkish names. */
export function sortSabitLookup(rows) {
    if (!Array.isArray(rows)) return [];
    return [...rows].sort((a, b) => {
        const left = sequence(a);
        const right = sequence(b);
        if (left !== right) {
            if (left === null) return 1;
            if (right === null) return -1;
            return left - right;
        }
        return nameCollator.compare(String(a?.ST_AD ?? '').trim(), String(b?.ST_AD ?? '').trim());
    });
}
